
import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { Button } from '@mui/material';

import './BeforeFooter.scss'

export default function BeforeFooter(props) {
  const action = props.action || null;
  const href = action ? undefined : (props.href || '#'); // href should be undefined if onclick action is defined
  const buttonLabel = props.buttonLabel || 'GET A QUOTE';

  return (
    <Row className={`${props.isModernized ? "modernized" : ""} before-footer`}>
      <Col lg className='w-100'>
        <Row className={`justify-content-center  ${props.isModernized ? "" : " pb-5"}`}>
          <h2 className="text-center">{props.title}</h2>
        </Row>
        <Row className="justify-content-center">
          <Button variant={`${props.isModernized ? "contained" : "outlined" }`} size="large" href={href} onClick={action} className={`btn-wide-sm  ${props.isModernized ? "button-action" : "button-white"}`}>{buttonLabel}</Button>
        </Row>
      </Col>
    </Row >
  );
}
